// Factory function pattern to avoid Webpack TDZ issues with class inheritance
// This uses BaseSuperAdminFactory instead of class inheritance

import { createBaseSuperAdmin, type IBaseSuperAdmin } from "../BaseSuperAdminFactory";
import type { FoldersInstance } from "./helpers/foldersInstanceHelpers";
import { createFoldersInstance } from "./helpers/foldersInstanceHelpers";
import { createApiFactory } from "@Front/Api/helpers/BaseApiFactoryGenerator";

const factory = createApiFactory<IBaseSuperAdmin, FoldersInstance>({
	name: "Folders",
	createBase: createBaseSuperAdmin,
	createInstance: createFoldersInstance,
});

export function getFoldersInstance(): FoldersInstance {
	return factory.getInstance();
}
